var React = require('react');

function ArrowRightLong (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z"}));
}

ArrowRightLong.defaultProps = {"fill":"currentColor","height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = ArrowRightLong;

ArrowRightLong.default = ArrowRightLong;
